var React = require('react');

function Cancelled (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.441 9.331a4.2 4.2 0 0 0 5.89-5.89l-5.89 5.89zm-.789-.795l5.884-5.884a4.2 4.2 0 0 0-5.884 5.884zM6 11.32A5.32 5.32 0 1 1 6 .68a5.32 5.32 0 0 1 0 10.64z","fill":"currentColor"}));
}

Cancelled.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14"};

module.exports = Cancelled;

Cancelled.default = Cancelled;
